import type { TaskStatus } from '@voll-intelligence/domain';

import { twcn } from '@web/ui/core/utils';

const SEGMENT_TONE: Record<TaskStatus, string> = {
  done: 'bg-tone-green-fg',
  running: 'bg-ai',
  blocked: 'bg-tone-amber-fg',
  failed: 'bg-tone-red-fg',
  pending: 'bg-tone-gray-fg',
};

interface ProgressBarProps {
  /** One segment per task, tone-coded by status (task order preserved). */
  statuses: readonly TaskStatus[];
}

/**
 * Segmented progress line — one tone-coded segment per task, filling the
 * available width. Used on the conversation board card footer. Renders
 * nothing when there are no tasks.
 */
export function ProgressBar({ statuses }: Readonly<ProgressBarProps>): React.JSX.Element | null {
  if (statuses.length === 0) return null;
  return (
    <span aria-hidden className="flex h-1.5 gap-0.5">
      {statuses.map((status, i) => (
        <span key={`${String(i)}-${status}`} className={twcn('w-2 h-full', SEGMENT_TONE[status])} />
      ))}
    </span>
  );
}
